// jobConstants.js
'use strict';

export const JOB_TYPE = {
  checkoutDiamondPack: 'checkout-diamond-pack',
  prepaid: 'prepaid',
};
